import SaccSarrIntegrazione from "./pages/SaccSarrPage.vue";

export default {
    SaccSarrIntegrazione,
}